export default __webpack_public_path__ + "static/char-42-98cc77818ba66fa815da4fba8fb7bb6c.webp";